import { newsApi } from "./api";

export const IftaComplianceService = newsApi.injectEndpoints({
  endpoints: (build) => ({
    getIfta: build.query({
      query: ({ pagination }) => ({
        url: `filling/get${pagination && pagination}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Driver"],
    }),
    getFuelRates: build.query({
      query: () => ({
        url: `fuel-rates`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: [""],
    }),
    addIfta: build.mutation({
      query: (form) => ({
        url: `filling/store`,
        method: "POST",
        body: form,
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Driver"],
    }),
    updateStatusIfta: build.mutation({
      query: ({id, status}) => ({
        url: `filling/update-status/${id}/${status}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Driver"],
    }),
    addIftaTripEntry: build.mutation({
      query: (form) => ({
        url: `filling/trip-entry`,
        method: "POST",
        body: form,
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Driver"],
    }),
    addIftaTripEntryPublic: build.mutation({
      query: ({ form, slug }) => ({
        url: `public-filling/trip-entry/${slug}`,
        method: "POST",
        body: form,
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Driver"],
    }),
    editIftaTripEntry: build.mutation({
      query: (form) => ({
        url: `filling/update/trip-entry`,
        method: "POST",
        body: form,
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Driver"],
    }),
    editBroker: build.mutation({
      query: ({ id, newForm }) => ({
        url: `broker-companies/update/${id}`,
        method: "PUT",
        body: newForm,
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Driver"],
    }),
    getIftaDetail: build.query({
      query: ({ id }) => ({
        url: `filling/view/${id}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: [""],
    }),
    getIftaDetailPublic: build.query({
      query: ({ id }) => ({
        url: `public-filling/get/${id}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: [""],
    }),
    removeIftaTripEntry: build.mutation({
      query: (id) => ({
        url: `filling/delete-trip-entry/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Driver"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetIftaQuery,
  useAddIftaMutation,
  useAddIftaTripEntryMutation,
  useEditIftaTripEntryMutation,
  useGetFuelRatesQuery,
  useUpdateStatusIftaMutation,
  useEditBrokerMutation,
  useGetIftaDetailQuery,
  useRemoveIftaTripEntryMutation,
  useRemoveBrokerMutation,
  useAddIftaTripEntryPublicMutation,
  useGetIftaDetailPublicQuery,
} = IftaComplianceService;
